import React from 'react';
import InternalLinkButton from '../ui/buttons/InternalLinkButton';
import BaseText from '../ui/typography/BaseText';
import { FONT_SIZE } from '../../constants/enum';

export default function FloatingCta() {
  return (
    <div className="rounded bg-blue-350 p-6 sticky top-28">
      <h2 className="text-2xl text-bold leading-7">Register your company with Air Corporate</h2>
      <h2 className="text-white text-medium mb-10 text-xl leading-7 mt-4">Pay less, get more</h2>
      <InternalLinkButton />
      <BaseText
        textColor="text-blue-50"
        fontSize={FONT_SIZE?.PX_14}
        className="mt-6"
        title="100% online and hassle-free"
      />
    </div>
  );
}
